import React, { useState, useEffect } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import API_BASE_URL from "../config";  // ADD THIS LINE

const data = language === "en" ? dataEn : dataKin;

const UpdateMaritalInfo = ({ christian, onUpdate, onCancel }) => {
  const [formData, setFormData] = useState({
    marital_status: '',
    spouse_name: '',
    widowed: '',
    death_date: '',
    widowed_spouse_name: '',
    divorced: '',
    divorce_date: '',
    divorced_spouse_name: ''
  });

  useEffect(() => {
    if (christian) {
      setFormData({
        marital_status: christian.marital_status || '',
        spouse_name: christian.spouse_name || '',
        widowed: christian.widowed || '',
        death_date: christian.death_date || '',
        widowed_spouse_name: christian.widowed_spouse_name || '',
        divorced: christian.divorced || '',
        divorce_date: christian.divorce_date || '',
        divorced_spouse_name: christian.divorced_spouse_name || ''
      });
    }
  }, [christian]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API_BASE_URL}/christian/update/${christian.id}`,  // CHANGE THIS LINE
        formData
      );
      onUpdate();
    } catch (error) {
      console.error("Error updating marital info:", error);
      alert("Failed to update marital info. Check console for details.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.marital}
          </label>
          <select
            name="marital_status"
            value={formData.marital_status}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select marital status</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Widowed">Widowed</option>
            <option value="Divorced">Divorced</option>
          </select>
        </div>

        {formData.marital_status === 'Married' && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {data.allChristianTable.spouse}
            </label>
            <input
              type="text"
              name="spouse_name"
              value={formData.spouse_name}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        )}

        {formData.marital_status === 'Widowed' && (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Widowed Status
              </label>
              <select
                name="widowed"
                value={formData.widowed}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Death Date
              </label>
              <input
                type="date"
                name="death_date"
                value={formData.death_date}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Widowed Spouse Name
              </label>
              <input
                type="text"
                name="widowed_spouse_name"
                value={formData.widowed_spouse_name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </>
        )}

        {formData.marital_status === 'Divorced' && (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Divorced Status
              </label>
              <select
                name="divorced"
                value={formData.divorced}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Divorce Date
              </label>
              <input
                type="date"
                name="divorce_date"
                value={formData.divorce_date}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Divorced Spouse Name
              </label>
              <input
                type="text"
                name="divorced_spouse_name"
                value={formData.divorced_spouse_name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </>
        )}
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>
    </form>
  );
};

export default UpdateMaritalInfo;